import { Routes } from '@angular/router';
import { ExecutiveDashboardComponent } from '../components/views/executive-dashboard/executive-dashboard.component';

export const EXECUTIVE_ROUTES: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: ExecutiveDashboardComponent }
];
